import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { IDataCategory } from '../../../../interfaces/IDataCategory';
import { Router } from '@angular/router';
import { DataCategoryService } from '../../../services/data-category.service';
import { forkJoin, take, takeWhile } from 'rxjs';
import { CategoryMenuComponent } from '../category-menu/category-menu.component';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'ra-category',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CategoryMenuComponent,
    DialogModule,
    CategoryMenuComponent,
  ],
  templateUrl: './category.component.html',
  styleUrl: './category.component.scss',
})
export class CategoryComponent implements OnInit, OnDestroy {
  @ViewChild('menuElement', { static: false }) menuElement!: ElementRef;
  @Input() amountCol = 4;

  dataCategory: IDataCategory[][] = [];

  readonly array = Array;
  readonly math = Math;
  readonly math1 = Math;

  isAlive = true;

  mapStatusOpenedMenu = new Map<string, boolean>();

  isOpened = false;
  isOpenedMobileMenu = false;

  currentIndex = 0;

  menuSVG = '/assets/icons/header/category/menu.svg';
  closeSVG = '/assets/icons/header/category/close.svg';

  menu = [
    {
      type: 'Транспорт',
      svg: '/assets/icons/header/category/avto.svg',
    },
    {
      type: 'Спецтехника',
      svg: '/assets/icons/header/category/spectehnika.svg',
    },
    {
      type: 'Коммерческая недвижимость',
      svg: '/assets/icons/header/category/kom-nedvizhimost.svg',
    },
  ];

  arrNamingCre = [
    {
      id: 1,
      name: 'shopping-mall',
    },
    {
      id: 2,
      name: 'street-retail',
    },
    {
      id: 3,
      name: 'business-center',
    },
    {
      id: 4,
      name: 'storage-facilities',
    },
    {
      id: 5,
      name: 'industrial-space',
    },
    {
      id: 6,
      name: 'multifunctional-complex',
    },
  ];

  constructor(
    private _renderer: Renderer2,
    @Inject(PLATFORM_ID) private _platformId: object,
    private router: Router,
    private dataCategoryService: DataCategoryService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    this.isAlive = false;
  }

  ngOnInit(): void {
    this.initDataForButtonCategory();

    this.dataCategoryService.statusOpened$
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((status) => {
        if (status === undefined) return;

        if (status === this.isOpened) return;
        this.isOpened = status;
        this.handleClassBody();
      });
  }

  getElementPosition() {
    const element = this.menuElement.nativeElement;
    const rect = element.getBoundingClientRect();
    const topMenu = Math.floor(rect.top);
    const newHeight = window.innerHeight - topMenu;

    this.menuElement.nativeElement.style.height = `${newHeight}px`;
    this.cdr.detectChanges();
  }

  initDataForButtonCategory(): void {
    forkJoin([
      this.dataCategoryService.getVehicleGroupsWithBodyTypes(),
      this.dataCategoryService.getUsageTypes(),
      this.dataCategoryService.getObjectTypes(),
    ])
      .pipe(take(1))
      .subscribe(([vehicleGroups, usageTypes, objectTypes]) => {
        const avto = vehicleGroups
          .filter((item) => item.type === 'avto')
          .map((item) => ({
            type: item.displayName,
            values: item.bodyTypes,
            id: item.id,
          }));

        const spec = vehicleGroups
          .filter((item) => item.type !== 'avto')
          .map((item) => ({
            type: item.displayName,
            values: item.bodyTypes,
            id: item.id,
          }));

        const obj = [];

        const rent = usageTypes.map((item) => ({
          id: item.id,
          linkCre: item.fullName_en_US.split(' ').join('-').toLocaleLowerCase(),
          name: item.fullName,
        }));

        const modernObjectTypes = objectTypes.map((item) => ({
          ...item,
          linkCre: this.arrNamingCre.find((i) => i.id === item.id)?.name ?? '',
        }));

        obj.push({ type: 'Арендовать', values: rent });
        obj.push({ type: 'Сдать', values: modernObjectTypes });

        this.dataCategory.push(avto, spec, obj);
      });
  }

  handleOpened(): void {
    this.isOpened = !this.isOpened;
    this.isOpenedMobileMenu = false;
  }

  selectTab(index: number, isMobile = false) {
    if (isMobile) this.isOpenedMobileMenu = true;

    if (this.currentIndex === index) return;

    this.currentIndex = index;
    this.mapStatusOpenedMenu.clear();
  }

  handleStatusOpened(e?: Event): void {
    if (e) e.stopPropagation();

    this.isOpened = !this.isOpened;

    this.cdr.detectChanges();

    if (this.menuElement) {
      this.getElementPosition();
    }

    if (!this.isOpened) this.mapStatusOpenedMenu.clear();
    this.handleClassBody();
  }

  handleClassBody() {
    if (isPlatformBrowser(this._platformId)) {
      const body = document.body;
      this.isOpened
        ? this._renderer.addClass(body, 'overflow-hidden')
        : this._renderer.removeClass(body, 'overflow-hidden');
    }
  }

  setNewValue(type: string) {
    const value = !this.mapStatusOpenedMenu.get(type);
    this.mapStatusOpenedMenu.set(type, value);
  }

  getMenu(rowIndex: number, colIndex: number) {
    return this.dataCategory[this.currentIndex][rowIndex * 4 + colIndex];
  }
}
